import colors from '../tokens/colors';

export const buttonGetolo = {
  base: {
    border: 'none',
    borderRadius: 8,
    container: {
      margin: {
        mobile: '1.5rem 0 1.5rem',
        desktop: '3rem 0 1.5rem',
      },
    },
    minHeight: {
      desktop: '4rem',
      mobile: '3.5rem',
    },
    minWidth: {
      mobile: '100%',
      desktop: '21.375rem',
    },
    margin: {
      mobile: '0 auto',
    },
    padding: {
      mobile: '0.75rem 1rem',
    },
  },
  states: {
    hover: {
      overlayColor: colors.BLACK,
      backgroundColor: null,
      opacity: 0.15,
    },
    focusVisible: {
      outline: {
        width: 3,
        color: colors.PROFESSIONAL_BLUE,
        offset: 2,
      },
    },
    active: {},
    disabled: {
      opacity: 0.6,
    },
  },
};

export const buttonDaDirekt = {
  base: {
    border: 'none',
    borderRadius: 4,
    container: {
      margin: {
        mobile: '1.5rem 0 1.5rem',
        desktop: '2rem 0 1.5rem',
      },
    },
    minHeight: {
      desktop: '3.5rem',
      mobile: '3.5rem',
    },
    minWidth: {
      mobile: '100%',
      desktop: '50%',
    },
    margin: {
      mobile: 0,
    },
    padding: {
      mobile: '0.75rem 1rem',
    },
  },
  states: {
    hover: {
      overlayColor: 'transparent',
      backgroundColor: colors.DA_DIREKT_BUTTON_HOVER,
      opacity: 0,
    },
    focusVisible: {
      outline: {
        width: 2,
        color: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
        offset: 2,
      },
    },
    active: {
      backgroundColor: colors.DA_DIREKT_BUTTON_ACTIVE,
    },
    disabled: {
      opacity: 0.3,
    },
  },
};

export const buttonDaKaufland = {
  base: {
    border: 'none',
    borderRadius: 0,
    container: {
      margin: {
        mobile: '1.5rem 0 1.5rem',
        desktop: '2rem 0 1.5rem',
      },
    },
    minHeight: {
      desktop: '2.75rem',
      mobile: '2.75rem',
    },
    minWidth: {
      mobile: '100%',
      desktop: 'auto',
    },
    margin: {
      mobile: 0,
    },
    padding: {
      mobile: '0.5rem 1rem',
    },
  },
  states: {
    hover: {
      overlayColor: 'transparent',
      backgroundColor: colors.DA_KAUFLAND_BLACK,
      opacity: 0,
    },
    focusVisible: {
      outline: {
        width: 2,
        color: colors.DA_KAUFLAND_RED,
        offset: 2,
      },
    },
    disabled: {
      opacity: 0.3,
    },
  },
};

export const buttonFressnapf = {
  base: {
    border: 'none',
    borderRadius: 10,
    container: {
      margin: {
        mobile: '1.5rem 0 1.5rem',
        desktop: '3rem 0 1.5rem',
      },
    },
    minHeight: {
      desktop: '4rem',
      mobile: '3.5rem',
    },
    minWidth: {
      mobile: '100%',
      desktop: '21.375rem',
    },
    margin: {
      mobile: '0 auto',
    },
    padding: {
      mobile: '0.75rem 2.5rem',
    },
  },
  states: {
    hover: {
      overlayColor: 'transparent',
      backgroundColor: colors.FRESSNAPF_PRIMARY_HOVER,
      opacity: '',
    },
    focusVisible: {
      boxShadowLevel: 2,
      outline: {
        width: 3,
        color: colors.FRESSNAPF_TEXT_PRIMARY,
        offset: 2,
      },
    },
    disabled: {
      opacity: 0.3,
    },
  },
};
